import { format } from 'date-fns';

export const getTodayStart = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
};

export const mapAllocationsByDay = (allocations) => {
  const mapped = {};
  (allocations || []).forEach((allocation) => {
    if (!allocation.date) return;
    const key = format(new Date(allocation.date), 'yyyy-MM-dd');
    if (!mapped[key]) mapped[key] = [];
    mapped[key].push(allocation);
  });
  Object.keys(mapped).forEach((key) => {
    mapped[key].sort((a, b) => new Date(a.startTime) - new Date(b.startTime));
  });
  return mapped;
};

export const mapAvailabilitiesByDay = (employeeAvailabilities) => {
  const mapped = {};
  (employeeAvailabilities || []).forEach((availability) => {
    if (!availability.date) return;
    const key = format(new Date(availability.date), 'yyyy-MM-dd');
    if (!mapped[key]) mapped[key] = [];
    mapped[key].push(availability);
  });
  Object.keys(mapped).forEach((key) => {
    mapped[key].sort((a, b) => new Date(a.startTime) - new Date(b.startTime));
  });
  return mapped;
};

export const mergeDayMaps = (target, source) => {
  Object.keys(source).forEach((key) => {
    if (!target[key]) {
      target[key] = [...source[key]];
      return;
    }
    const existingIds = new Set(target[key].map((item) => item._id || item.id));
    source[key].forEach((item) => {
      const id = item._id || item.id;
      if (!existingIds.has(id)) {
        target[key].push(item);
      }
    });
    target[key].sort((a, b) => new Date(a.startTime) - new Date(b.startTime));
  });
  return target;
};

export const hasPendingApplication = (allocation, employeeId) =>
  allocation?.applications?.some(
    (app) => app.employee?._id?.toString() === employeeId?.toString() && app.status === 'pending'
  );

export const hasAnyApplication = (allocation, employeeId) =>
  allocation?.applications?.some((app) => app.employee?._id?.toString() === employeeId?.toString());

export const isAssignedAvailability = (availability) =>
  availability?.isAssigned || availability?.shiftAllocationId?._id;

export const getEmployeeInitials = (name) => {
  if (!name || typeof name !== 'string') return '?';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] || ''}${parts[parts.length - 1][0] || ''}`.toUpperCase();
};
